"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Col = exports.Row = exports.Grid = void 0;

var _styledSystem = require("styled-system");

var _styledBootstrapGrid = require("styled-bootstrap-grid");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * TODO: v2 of `styled-bootstrap-grid` contains TS typings, but we need to
 * upgrade to styled-components 4 before it's possible to upgrade to v2.
 */
var Grid = (0, _styledComponents.default)(_styledBootstrapGrid.Container).withConfig({
  displayName: "Grid",
  componentId: "etz25q-0"
})(["overflow:hidden;max-width:", "px;", ";"], function (props) {
  return props.theme.grid.breakpoints.xl;
}, _styledSystem.space);
/** Grid row */

exports.Grid = Grid;
var Row = (0, _styledComponents.default)(_styledBootstrapGrid.Row).withConfig({
  displayName: "Grid__Row",
  componentId: "etz25q-1"
})(["", ";", ";"], _styledSystem.color, _styledSystem.space);
/** Grid column */

exports.Row = Row;
var Col = (0, _styledComponents.default)(_styledBootstrapGrid.Col).withConfig({
  displayName: "Grid__Col",
  componentId: "etz25q-2"
})(["", ";", ";", ";", ";", ";"], _styledSystem.color, _styledSystem.flex, _styledSystem.space, _styledSystem.textAlign, _styledSystem.width);
exports.Col = Col;
Grid.displayName = "Grid";
Row.displayName = "Row";
Col.displayName = "Col";
//# sourceMappingURL=Grid.js.map